import { connect } from 'react-redux';
import { getUnitsExecutionState } from '../../../reducers/analyticsApp';
import RetentionSimplePreview from '../../../components/dashboards/preview/RetentionSimplePreview';

const mapStateToProps = (state, { unit }) => {
  const unitExecute = getUnitsExecutionState(state)[unit.id];
  const { options } = unit.compose.retention;

  const executedQuery = unitExecute.query;

  return {
    result: unitExecute.result,
    timezone: executedQuery ? executedQuery.timezone : null,
    dimensionType: executedQuery ? executedQuery.sequence.type : null,
    sequence: executedQuery ? executedQuery.sequence.units : null,
    executeTime: unitExecute.executeTime,
    options,
    executedQuery,
  };
};

export default connect(mapStateToProps)(RetentionSimplePreview);
